import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2;

import { css, memoizeStyle } from "../../../lib/theming/Emotion";
import { paddingX } from "../helpers";
export var styles = memoizeStyle({
  rootSmall: function rootSmall(t) {
    return tabsRoot(t, 'small');
  },
  rootMedium: function rootMedium(t) {
    return tabsRoot(t, 'medium');
  },
  rootLarge: function rootLarge(t) {
    return tabsRoot(t, 'large');
  },
  vertical: function vertical() {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      margin: 0;\n    "])));
  }
});

function tabsRoot(t, size) {
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    display: inline-block;\n    margin: 0 -", ";\n    padding: 0;\n    position: relative;\n  "])), paddingX(t, size));
}